import { Component, ElementRef, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-attention-modal',
  templateUrl: 'attention-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, NgTemplateOutlet],
})
export class AttentionModalComponent {
  @Input() type!: 'warning' | 'error' | 'success' | 'scheduled';

  @Input() title!: string;

  @Input() subtitle?: string;

  @Input() messageTemplate!: TemplateRef<ElementRef>;

  @Input() buttonsTemplate!: TemplateRef<ElementRef>;
}
